import { httpRequest } from "@services/http";
import { Debit } from "@models/debit.model";
import { DebitSerializer } from "@models/serializers/debitSerializer";

export interface UpdateDebitPayload {
  amount?: number;
  effective_date?: string | null;
  reporter?: string | null;
  source_type?: string;
  reason?: string | null;
}

export class CommandUpdateDebit {
  async run(contractId: number, debitId: number, payload: UpdateDebitPayload): Promise<Debit> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/finance/contracts/${contractId}/debits/${debitId}/`;
    const response = await httpRequest<any>(url, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
    return DebitSerializer.fromJson(response);
  }
}
